import { AVAILABLE_ROLES_BY_TYPE, ProjectMemberRoleType } from '@projectMembers/models/projectRole';

type ProjectJSON = {
	id: number;
	name: string;
};

export type ProjectInvitationJSON = {
	id: number;
	hash: string;
	email: string;
	role: {
		id: number;
		type: ProjectMemberRoleType;
	};
	project: ProjectJSON;
};

type ProjectInvitationParams = {
	id: number,
	hash: string,
	email: string,
	roleType: ProjectMemberRoleType,
	projectID: number,
	projectAttributes: ProjectJSON
};

export default class ProjectInvitation {
	id: number;
	hash: string;
	email: string;
	roleType: ProjectMemberRoleType;
	projectID: number;
	projectAttributes: ProjectJSON;

	constructor( {
		id,
		hash,
		email,
		roleType,
		projectID,
		projectAttributes
	}: ProjectInvitationParams ) {
		this.id = id;
		this.hash = hash;
		this.email = email;
		this.roleType = roleType;
		this.projectID = projectID;
		this.projectAttributes = projectAttributes;
	}

	get role() {
		return AVAILABLE_ROLES_BY_TYPE[ this.roleType ];
	}

	static fromJson( properties: ProjectInvitationJSON ) {
		return new ProjectInvitation( {
			id: properties.id,
			hash: properties.hash,
			email: properties.email,
			roleType: properties.role.type,
			projectID: properties.project.id,
			projectAttributes: properties.project
		} );
	}

	toJson() {
		return {
			id: this.id,
			hash: this.hash,
			email: this.email,
			role: {
				id: this.id,
				type: this.roleType
			},
			project: this.projectAttributes
		};
	}
}
